import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/auth/auth.service';
import { CommonPin } from '../common-pin/common-pin';
import { BiometricService } from '../services/capacitor-biometric.class';

@Component({
  selector: 'global-confirm-component',
  templateUrl: './global-confirm.component.html',
  styleUrls: ['./global-confirm.component.scss']
})
export class ModalGlobalConfirmComponent extends CommonPin implements AfterViewInit {
  isLoading: boolean = false;
  @ViewChild("pinInput")
  pinInputControl!: ElementRef;
  wrongPin: boolean = false;
  smthWrong: boolean = false;

  pin: string = "";

  get contains4ch(): boolean {
    return this.pin.length == 4;
  }

  constructor(public modalCtrl: ModalController,
    private authService: AuthService,
    public biometricService: BiometricService,
    private router: Router,
  ) {
    super(biometricService,modalCtrl);
  }

  ngAfterViewInit(): void {
    setTimeout(()=>{ 
      if(!this.pinInputControl||!this.pinInputControl.nativeElement) return;
      this.pinInputControl.nativeElement.focus();
    },2); 
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  checkPin() {
    this.authService.getUserAttributes((err: any) => {
      //TODO Add correct notification
      this.smthWrong = true;
      console.log(err?.message || JSON.stringify(err));
    }
      , (res: any) => {
        if (res?.find((el: any) => el.Name == 'custom:pin' && el.Value == this.pin)) {
          return this.modalCtrl.getTop().then((p:any)=>{
            if(p)p.canDismiss = true;
            return this.modalCtrl.dismiss(true, 'confirm');
          });
        } else {
          this.wrongPin = true;
          this.smthWrong = false;
          this.pin = '';
        }
        return;
      });
  }

  onChange() {
    if (!this.contains4ch) return;
    this.smthWrong = false;
    this.checkPin();
  }

  forgotPinClicked(){
    this.router.navigate(["dashboard/remind-pin"]);
    this.modalCtrl.getTop().then((p:any)=>{
      if(p)p.canDismiss = true;
      this.modalCtrl.dismiss(false, 'cancel');
    });
  }
}